



























































































































































































































































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {urlWithContour} from "@/helpers/currentContour";
import Modal from "@/components/UI/Modal.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import TooltipWithClose from '@/components/UI/TooltipWithClose.vue';
import Search from '@/components/UI/Search.vue';
import IBarcode from "@/components/icons/IBarcode.vue";
import IQrcode from '@/components/icons/IQrcode.vue'
import IClose from '@/components/icons/IClose.vue'
import IArrow from '@/components/icons/IArrow.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IGenerate from '@/components/icons/IGenerate.vue'
import VueQrcode from 'vue-qrcode'
import SelectedBadge from '@/components/beta/Settings/SelectedBadge.vue';
import Alert from '@/components/UI/Alert.vue';
import ISwitcher from '@/components/icons/ISwitcher.vue'


const badges = namespace('badges')
const profile = namespace('profile')
const alerts = namespace('alerts')

@Component({
  components: {
    IBarcode,
    Modal,
    BtnDefault,
    Tooltip,
    TooltipWithClose,
    Search,
    IQrcode,
    IClose,
    IArrow,
    ITrash,
    VueQrcode,
    SelectedBadge,
    IGenerate,
    Alert,
    ISwitcher,
  }
})

export default class Badges extends Vue {
  @profile.Getter('getCurrentCompany') protected getCurrentCompany: any

  @badges.Action('patchCompanyMember') protected patchCompanyMember: any
  @badges.Action('refreshCodeInvite') protected refreshCodeInvite: any
  @badges.Mutation('setCodeInvite') protected setCodeInvite: any
  @badges.Action('getCodeInvite') protected getCodeInvite: any
  @badges.Getter('loadingCodeInvite') protected loadingCodeInvite: any
  @badges.Getter('codeInvite') protected codeInvite: any


  @badges.Action('getCompanyMembers') protected getCompanyMembers: any
  @badges.Action('getCompanyMember') protected getCompanyMember: any
  @badges.Action('getCompanyMembersByImport') protected getCompanyMembersByImport: any
  @badges.Action('addCompanyMember') protected addCompanyMember: any
  @badges.Action('deactivateCompanyMember') protected deactivateCompanyMember: any

  @badges.Getter('loadingBadgesByImport') protected loadingBadgesByImport: any
  @badges.Getter('loadingBadges') protected loadingBadges: any
  @badges.Getter('addCompanyMemberLoading') protected addCompanyMemberLoading: any
  @badges.Getter('badges') protected badges: any
  @badges.Getter('badgeByImport') protected badgeByImport: any
  @badges.Getter('count') protected count: any
  @profile.Getter('getUser') protected getUser: any

  @badges.Mutation('clearModule') protected clearModule: any

  @alerts.Mutation('setAlert') protected setAlert: any

  urlQr:any = urlWithContour

  disableBtn: boolean = false
  search: string = ''
  curBadgeLink: string = ''
  curBarBadgeLink: string = ''
  isShowQrcode: boolean = false
  isShowBarcode: boolean = false
  isMinTable: boolean = false
  currentBadgeQrcode: any = {}
  currentBadge: any = {}
  isShowDeleteBadge: boolean = false
  isShowAddBadge: boolean = false
  loading: boolean = false
  selectedBadges: any = []
  isErrorAddBadges: boolean = false
  selected: [] = []
  showTooltip: boolean = false


  code: string = ''
  isShowDeleteCode: boolean = false
  isShowGenerateCode: boolean = false
  loadingDeleteCode: boolean = false
  loadingGenerateCode: boolean = false

  trusted: boolean = false

  get headers() {
    return [
      {text: '', value: 'barcode', sortable: false, align: 'start', width: '70'},
      {text: '', value: 'qrcode', sortable: false, width: '70'},
      {text: this.$t('badges.table.name'), value: 'first_last', sortable: false},
      {text: this.$t('badges.expansions.about.position'), value: 'position', sortable: false},
      {text: this.$t('badges.table.phone'), value: 'phone', sortable: false},
      {text: this.$t('badges.table.email'), value: 'email', sortable: false},
      // {text: this.$t('badges.table.mailing'), value: 'trusted', sortable: false, width: '320', align: 'end'},
      {text: this.$t('badges.table.mailing'), value: 'mailing', sortable: false, width: '200'},
      // {text: 'Login', value: 'login', sortable: false},
      // {text: this.$t('badges.table.phone'), value: 'login', sortable: false},
      {text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deleteBadge'},
    ]
  }

  get headersMin() {
    return [
      // {text: '', value: 'barcode', sortable: false, align: 'start', width: '70'},
      {text: '', value: 'qrcode', sortable: false, width: '70'},
      {text: this.$t('badges.table.name'), value: 'first_last', sortable: false},
      {text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deleteBadge'},
    ]
  }

  get headersAdd() {
    return [
      {text: this.$t('badges.table.phone'), value: 'login', sortable: false},
      {text: this.$t('badges.table.name'), value: 'first_last', sortable: false},
    ]
  }

  get searchedBadges() {
    return this.search ? this.badges.filter((badge: any) => badge.first_last.toLowerCase().includes(this.search.toLowerCase())) : this.badges
  }

  @Watch('selectedBadges')
  setError() {
    this.isErrorAddBadges = false
  }

  beforeDestroy() {
    this.clearModule()
  }

  getMember() {
    this.getCompanyMembers({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      query: {
        excludeCurrentUser: 0,
        status: 'active',
        sort: 'lastName',
      }
    })
  }

  mounted() {
    this.getMember()
    this.getCodeInvite({
      params: {
        companyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      }
    })
    let body = document.querySelector('body') as HTMLElement
    body.addEventListener('click', () => {
      this.showTooltip = false
    })
  }

  deleteCode() {
    this.loadingDeleteCode = true
    setTimeout(() => {
      this.loadingDeleteCode = false
      this.isShowDeleteCode = false
      this.code = ''
    }, 1000)
  }

  generateCode() {
    this.isShowGenerateCode = false
    this.refreshCodeInvite({
      params: {
        companyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      }
    })
  }

  copyCode() {
    if (this.code) {
      let area = document.createElement('textarea');
      document.body.appendChild(area);
      area.value = `${this.$t('badges.code.label')}` + ': ' + this.codeInvite;
      area.select();
      document.execCommand("copy");
      document.body.removeChild(area);
      this.setAlert({
        show: true,
        messages: [this.$t('badges.code.copy')],
      })
    }
  }

  openImport() {
    this.selectedBadges = []
    this.isShowAddBadge = true
    this.getCompanyMembersByImport({
      params: {
        CompanyCode: this.$route.params.code,
        showCode: this.$route.params.showCode,
      },
      query: {
        withActiveUserParticipation: 0,
        sort: 'firstName',
      }
    })

  }

  rowClasses(item: any) {
    return (this.isMinTable && item.user_id == this.currentBadge.user_id) ? 'lfs-data-table-active' : ''
  }

  async deleteBadge() {
    await this.deactivateCompanyMember({
      params: {
        badgeId: this.currentBadge.userParticipation_id
      }
    })
    this.isShowDeleteBadge = false
    this.isMinTable = false
    // if(this.isMinTable && this.currentBadge.userParticipation_id){
    //
    // }
  }

  showQrcode(item: any) {
    this.curBadgeLink = `${urlWithContour()}/b/${item.userParticipation_id}`
    this.currentBadgeQrcode = item
    this.isShowQrcode = true
  }

  showBarcode(item: any) {
    this.curBarBadgeLink = item.userParticipation_barcode
    this.currentBadgeQrcode = item
    this.isShowBarcode = true
  }

  showDetails(item: any) {
    this.currentBadge = item
    this.isMinTable = true

    this.getCompanyMember({
      badgeId: item.userParticipation_id
    })
  }

  showModalDeleteBadge(item: any) {
    this.isShowDeleteBadge = true
    this.currentBadge = {...item}
  }

  destroyed() {
    this.setCodeInvite(null)
  }

  async addBadges() {
    // this.disableBtn = true
    this.isErrorAddBadges = this.selectedBadges.length == 0
    if (!this.isErrorAddBadges) {
      await this.addCompanyMember({
        params: {
          CompanyCode: this.$route.params.code,
          showCode: this.$route.params.showCode,
        },
        body: {
          members: this.selectedBadges.map((member: any) => {
            return member.user_id
          })
        }
      })
      this.isShowAddBadge = false
      // this.disableBtn = false

    }
  }

  toMembers() {
    this.$router.push({
      name: 'CompanySettings',
      params: {companyCode: this.$route.params.code},
      query: {tab: "companyMembers"}
    }).catch(() => {
    })
  }

  changeTrusted(item: any) {
    this.patchCompanyMember({
      params: {
        badgeId: item.userParticipation_id
      },
      body: {showBadgeContactsInEmail: !item.trusted}


    })
  }

}
